<div class="px-7 py-5 overflow-y-auto" style="max-height: calc(100vh - 300px);">
  <p class="text-[14px] font-bold text-[var(--primary-dark)] mb-1">Season Cost Management</p>
  <p class="text-[12px] text-[var(--tertiary-text)] mb-5">Apply cost values to all {{ allFieldDetailIds.length }} fields in this season.</p>

  <div *ngIf="isLoading" class="text-[13px] text-[var(--tertiary-text)] py-4">Loading cost options...</div>

  <div *ngIf="!isLoading" class="flex flex-col gap-2">
    <!-- Fixed Input Cost -->
    <mat-form-field class="w-[160px]" appearance="outline">
      <mat-label>Fixed input cost</mat-label>
      <input matInput type="number" [(ngModel)]="fixedCostValue" min="0" max="1000000">
    </mat-form-field>

    <!-- Two column layout -->
    <div class="flex gap-6 mt-3">
      <!-- VRT Column -->
      <div class="flex-1">
        <p class="text-[13px] font-bold text-[var(--base-text-alt-dark)] mb-3">VRT</p>
        <div class="max-h-[340px] overflow-y-auto border border-[var(--app-border)] rounded-lg p-3">
          <div class="grid grid-cols-2 gap-2">
            <div *ngFor="let input of vrtInputs" class="flex items-center gap-2">
              <mat-form-field class="w-[150px]" appearance="outline">
                <mat-label>{{ input.type }}</mat-label>
                <input matInput type="number" [(ngModel)]="input.costValue" min="0" max="1000000">
              </mat-form-field>
              <mat-form-field class="w-[140px]" appearance="outline">
                <mat-label>Unit of measure</mat-label>
                <mat-select [(ngModel)]="input.unitOfMeasureId">
                  <mat-option *ngFor="let uom of unitsOfMeasure" [value]="uom.id">{{ uom.description }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="vrtInputs.length === 0" class="text-[13px] text-[var(--tertiary-text)] py-3">No VRT cost options available.</div>
        </div>
      </div>

      <!-- As Applied Column -->
      <div class="flex-1">
        <p class="text-[13px] font-bold text-[var(--base-text-alt-dark)] mb-3">As Applied</p>
        <div class="max-h-[340px] overflow-y-auto border border-[var(--app-border)] rounded-lg p-3">
          <div class="grid grid-cols-2 gap-2">
            <div *ngFor="let input of asAppliedInputs" class="flex items-center gap-2">
              <mat-form-field class="w-[150px]" appearance="outline">
                <mat-label>{{ input.type }}</mat-label>
                <input matInput type="number" [(ngModel)]="input.costValue" min="0" max="1000000">
              </mat-form-field>
              <mat-form-field class="w-[140px]" appearance="outline">
                <mat-label>Unit of measure</mat-label>
                <mat-select [(ngModel)]="input.unitOfMeasureId">
                  <mat-option *ngFor="let uom of unitsOfMeasure" [value]="uom.id">{{ uom.description }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div *ngIf="asAppliedInputs.length === 0" class="text-[13px] text-[var(--tertiary-text)] py-3">No As Applied cost options available.</div>
        </div>
      </div>
    </div>

    <!-- Apply Button -->
    <div class="mt-5">
      <button (click)="apply()" [disabled]="isLoading"
        class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 disabled:opacity-40 disabled:cursor-default transition-all">
        Apply to All Fields
      </button>
    </div>
  </div>
</div>
